import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <span className="w-16 h-16 flex items-center justify-center mx-auto">
          <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
        </span>
        <h2 className="text-xl md:text-2xl font-bold text-foreground-800 mt-6" style={{ fontFamily: 'var(--font-heading)' }}>
          页面未找到
        </h2>
        <p className="mt-2 text-sm text-foreground-400">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">您访问的页面不存在或已被移除</p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link
            to="/"
            className="px-5 py-2.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/category/rexue"
            className="px-5 py-2.5 text-sm font-medium rounded-full bg-background-100 text-foreground-600 hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-200/60"
          >
            浏览漫画
          </Link>
        </div>
      </div>
    </div>
  );
}